import config from '@/config';
import logger from '@/util/logger';
import { initializeDao } from '@rock/dao';
import { clientAdapter, initializeFirebase } from '@rock/db-admin';

initializeFirebase(config.firebase.config, config.firebase.appCheckSiteKey);
initializeDao({ adapter: clientAdapter, loggerFactory: logger });
